export default __webpack_public_path__ + "static/media/handphone.f4b9862d.png";